function toVhVw(arg) {
  //if (arg.toString().endsWith('vw'))
  if (arg.toString()[arg.toString().length - 1] == "w")
    return (window.innerWidth / 100) * arg.toString().split("v")[0];
  else return (window.innerHeight / 100) * arg.toString().split("v")[0];
}

let General = {
  toVhVw: toVhVw,
};

export default General;

export const getMinutesFromHHMM = (info: string) => {
  if (info) {
    const item = parseInt(info.slice(0, 2));
    const hours: number = item * 60;
    const mins: number = parseInt(info.slice(3));
    return hours + mins;
  } else {
    return 0;
  }
};
